import React, { useContext, useState, useEffect, useMemo } from 'react'
/** @jsx jsx */
import { jsx } from '@emotion/core'
import { connect } from 'react-redux'
import { Button, Checkbox, DatePicker, message, Table } from 'antd'
import { processDerateNYISO, getBfNyIsoDerateGroup } from 'api/pgads'
import { columns, isErrorContains } from '../core/component/JcTmpErrorDialog'
import {
  DatePickerContext,
  ErrorContext,
  SpinContext,
  UnitSelectionContext,
} from 'context'
import { getEnvConfig, getPermitActions, getApiTargetInfo } from 'core'
import UnitSelection from 'core/component/UnitSelection'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Title,
} from 'core/screen-util'
import { getUnitNameMap, getUnits, getUtilityNameMap } from 'core/selectors'

const DerateNyIsoProcess = ({ apiTargetInfo, units }) => {
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const {
    selectedUnits,
    setSelectedUnits,
    setVisibleUnitSelection,
  } = useContext(UnitSelectionContext)

  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [data, setData] = useState([])
  const [resetFlag, setResetFlag] = useState(false)
  // const [fuzzyFilter, setFuzzyFilter] = useState('')
  const [derateUnits, setDerateUnits] = useState([])
  useEffect(
    _ => {
      setSelectedUnits([])
    },
    [setSelectedUnits]
  )

  useEffect(
    _ => {
      getBfNyIsoDerateGroup(apiTargetInfo).fork(
        _ => _,
        data => {
          setDerateUnits(data.map(d => d.unitId))
        }
      )
    },
    [apiTargetInfo]
  )
  useEffect(
    _ => {
      setData([])
    },
    [selectedUnits, selectedDate, resetFlag]
  )

  const limitedUnits = useMemo(
    _ => {
      if (derateUnits.length <= 0) return units
      else {
        return units.filter(f => derateUnits.includes(f.unitId))
      }
    },
    [derateUnits, units]
  )

  const retrieve = ({ date = selectedDate, selUnits = selectedUnits }) => {
    if (selUnits === undefined || selUnits.length < 1) {
      message.error('Please, Select Unit')
      setVisibleUnitSelection(true)
      return
    }
    setSpinning(true)

    processDerateNYISO(apiTargetInfo)({
      year: date.format('yyyy'),
      month: date.format('M'),
      resetFlag: resetFlag ? 'Y' : 'N',
      units: selUnits,
    }).fork(setError, data => {
      setSpinning(false)
      setData(data)
      if (!isErrorContains(data)) {
        message.info('Processed Successfully.')
      }
      // setData(
      //   data.map(d => ({
      //     ...d,
      //     utility: `${d.utility}-${utilityNameMap[d.utility]}`,
      //     unitId: `${d.unit}-${unitNameMap[d.unitId]}`,
      //     zoneDateStringZone: d.zoneDateString + d.zone,
      //   }))
      // )
    })
  }

  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <UnitSelection limitedUnits={limitedUnits} />

      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            width: '250px',
          }}
        >
          Process NYISO Derates
        </Title>

        <DatePicker.MonthPicker
          style={{ marginLeft: '15px' }}
          allowClear={false}
          format="MMMM-YYYY"
          value={selectedDate}
          onChange={d => {
            setSelectedDate(d)
            // retrieve({ dates: d })
          }}
        />

        <Button
          icon="database"
          loading={spinning}
          onClick={retrieve}
          css={{ marginLeft: '10px' }}
          type="primary"
        >
          Process
        </Button>
        <Checkbox
          checked={resetFlag}
          onChange={e => setResetFlag(e.target.checked)}
          style={{ marginLeft: '10px' }}
        >
          Reset and Delete All Data
        </Checkbox>
        <Filler />
      </CriteriaRow>
      <FullHeightSizer heightOffset={280}>
        {({ height }) => (
          <Content css={{ height: height - 20, paddingTop: '10px' }}>
            <div style={{ maxHeight: height - 150, height: height - 50 }}>
              <Table
                columns={columns}
                dataSource={data}
                onRow={record => {
                  if (record.severity === 1 || record.severity === '1') {
                    return { style: { backgroundColor: 'lightpink' } }
                  } else return { style: { backgroundColor: 'lightyellow' } }
                }}
                pagination={false}
                size="small"
                // style={{ maxHeight: '400px', overflowY: 'auto' }}
                scroll={{ y: height - 100 }}
                rowKey1={d => d.errorMessage + d.severity + d.errorCode}
              />
            </div>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  units: getUnits(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})
export default connect(mapStateToProps)(DerateNyIsoProcess)
